// src/helpers/translation/ua.js
export default {
  seo: {
    home: {
      title: 'Artemida Studio — Креативні цифрові рішення',
      description:
        'Ми створюємо індивідуальні вебсайти будь-якої складності: лендінги, корпоративні сайти та асистенти ШІ.',
      keywords: 'розробка вебсайтів, лендінг, корпоративний сайт, ШІ',
    },
    // 🔽 нове: SEO для списку блогу
    blog: {
      title: 'Блог — Artemida Studio',
      description:
        'Матеріали про веброзробку, дизайн, AI-асистентів і створення сучасних корпоративних сайтів.',
      keywords: 'блог, веброзробка, дизайн, ai, вебсайти',
    },
  },

  header: {
    homeLink: 'Головна',
    aboutUsLink: 'Про нас',
    servicesLink: 'Послуги',
    ourProjectsLink: 'Наші проєкти',
    contact: 'Контакти',
    blogLink: 'Блог',
  },
  heroSection: {
    companyDescription:
      'Ми створюємо індивідуальні вебсайти будь-якої складності',
    contactUs: 'Зв’яжіться з нами',
  },
  aboutUsSection: {
    aboutUsTitle: 'Про нас',
    aboutUsDescription:
      'У студії Artemida ми спеціалізуємося на створенні індивідуальних лендингів і корпоративних вебсайтів, які допомагають бізнесу вибудовувати сильну онлайн-присутність. Наша місія — надавати сучасні, функціональні та візуально вражаючі рішення, адаптовані до потреб вашого бренду.\n\n' +
      'Поєднуючи креативність, найновіші технології та персоналізований підхід, ми створюємо сайти, які не лише естетично привабливі, а й швидкі, зручні у користуванні та повністю адаптивні.\n\n' +
      'Чи потрібен вам висококонверсійний лендинг або професійний корпоративний сайт — Artemida Studio втілить вашу візію в життя завдяки індивідуальним рішенням високої якості.\n\n' +
      'Обирайте професіоналізм і креативність — створімо ваш ідеальний сайт разом!',
  },

  // Послуги (вся секція керується i18n)
  services: {
    ourServices: 'Наші послуги',
    servicesDescription:
      'Ми спеціалізуємося на створенні високоякісних, індивідуальних цифрових рішень, що розвивають ваш бізнес',
    contactUs: 'Зв’яжіться з нами',
    items: [
      {
        key: 'landing',
        title: 'Лендінг-\nсторінка',
        descriptionList: [
          'Добре спроєктований лендінг — потужний інструмент для залучення клієнтів, підвищення конверсій та посилення онлайн-присутності бренду. У Artemida Studio ми створюємо індивідуальні лендінги високої якості під ваші бізнес-цілі.',
          '✔️ Сучасний і унікальний дизайн — Візуально виразні, брендовані сторінки, що привертають увагу.',
          '✔️ Висока конверсія — Оптимізовані макети та переконливі CTA для зростання залучення.',
          '✔️ Швидко й адаптивно — Блискавична робота та безшовний досвід на всіх пристроях.',
          '✔️ Готовність до SEO та маркетингу — Розробка за кращими практиками для підвищення видимості та органічного трафіку.',
          '✔️ Повна кастомізація — Кожна деталь під ваші потреби та айдентику бренду.',
        ],
      },
      {
        key: 'corporate',
        title: 'Корпоративний сайт',
        descriptionList: [
          'Професійний корпоративний сайт — ключ до довіри, презентації бренду та взаємодії з клієнтами. У Artemida Studio ми створюємо кастомні сайти, що відображають цінності компанії та вирізняють вас у цифровому середовищі.',
          '✔️ Професійний і унікальний дизайн — Сучасний, охайний вигляд, узгоджений з айдентикою бренду.',
          '✔️ Повна гнучкість — Кожен елемент під ваші бізнес-цілі та вимоги.',
          '✔️ Швидко й безпечно — Оптимізовано для швидкодії, безпеки та стабільності.',
          '✔️ Дружній до SEO та маркетингу — Розробка за best practices для зростання видимості й лідів.',
          '✔️ Мобільність та зручність — Повністю адаптивний дизайн для бездоганного UX на всіх пристроях.',
          '✔️ Просте керування контентом — Швидкі оновлення через інтуїтивну CMS.',
        ],
      },
      {
        key: 'ai',
        title: 'Інтеграція асистентів ШІ',
        descriptionList: [
          'Прокачайте ваш сайт завдяки ШІ! У Artemida Studio ми інтегруємо сучасних AI-асистентів, що покращують UX, автоматизують процеси та підвищують залучення. Чатбот, автопідтримка чи рекомендації на базі ШІ — створимо рішення саме під ваш бізнес.',
          '✔️ Підтримка 24/7 — AI-чатботи обробляють звернення будь-коли, підвищуючи задоволеність.',
          '✔️ Безшовна інтеграція — Плавна робота всередині сайту без порушення функціоналу.',
          '✔️ Персоналізований досвід — Взаємодії на базі ШІ під потреби й вподобання користувачів.',
          '✔️ Ліди та продажі — Залучайте відвідувачів, збирайте контакти та ведіть до покупки.',
          '✔️ Автоматизація та ефективність — Оптимізація процесів, менше рутини та швидші відповіді.',
          '✔️ Індивідуальні AI-рішення — Повна адаптація під вашу модель бізнесу та специфічні вимоги.',
        ],
      },
    ],
  },
  contactSection: {
    title: 'Обговорімо ваш проєкт',
    placeholderName: "Ім'я",
    placeholderPhone: 'Телефон',
    placeholderEmail: 'Email',
    placeholderMessage: 'Розкажіть про ваш проєкт',
    sendButton: 'Надіслати',
  },
};
